import Content from "./content";
import { node, text } from "~/util/dom";
import { CONFIG } from "~/config";
import { store } from "~/state/store";
import { unsetDetail } from "~/state/detail/state";
import { _ } from "~/i18n";
import { getAttrLink } from "~/util/userweb";

function createRow(title: string, value: Array<string | HTMLElement>): HTMLTableRowElement {
	const row = node("tr");
	const titleCol = node("td", { className: "text" });
	const valueCol = node("td", {});

	titleCol.innerHTML = title;
	for (let index = 0; index < value.length; index++) {
		if (index > 0) {
			valueCol.appendChild(text(", "));
		}
		if (typeof value[index] === "string") {
			valueCol.appendChild(text(value[index] as string));
		} else {
			valueCol.appendChild(value[index] as HTMLElement);
		}
	}

	row.append(titleCol, valueCol);

	return row;
}

function createLinkItem(value: {
	type: "link";
	label: string;
	value: string;
}): HTMLAnchorElement {
	return node("a", {
		href: value.value,
		target: "_blank",
	}, value.label);
}

function createEnumItem(value: {
	type: "enum";
	value: string;
}): string {
	return value.value;
}

function createUnitItem(value: {
	"type": "unit";
	"unit": string;
	"value": number;
	"rawUnit": string;
	"rawValue": number;
}): string {
	return `${value.value.toLocaleString(Userweb.defaultLang)} ${value.unit}`;
}

function createPoiItem(value: {
	"type": "poi";
	"srcId": number;
	"srcSource": string;
	"title": string;
}): HTMLAnchorElement {
	return node("a", {
		href: `https://${CONFIG.BASE_DOMAIN}/${CONFIG.defaultLang}/?source=${value.srcSource}&id=${value.srcId}`,
		target: "_blank",
	}, value.title);
}

export default class KeyVal extends Content {
	_build() {
		const table = node("table");
		const tBody = node("tbody");
		const dataSource = node("div");

		dataSource.classList.add("content-keyval-data-source");
		dataSource.append(
			node("a", { href: getAttrLink(), textContent: _("covid.dataSource"), target: "_blank", rel: "noopener" }),
		);

		// FIXME zpetna kompatibilita, v budoucnu se muze odstranit
		this._data = Array.isArray(this._data) ? this._data : [this._data];

		this._dom.container.classList.add("content-keyval");

		this._data.forEach(keyval => {
			for (const [name, value] of Object.entries(keyval)) {
				const valueArray = Array.isArray(value) ? value : [value];
				const itemValue = [];

				valueArray.forEach(item => {
					if (typeof item === "object") {
						if (item.type === "enum") {
							itemValue.push(createEnumItem(item));
						} else if (item.type === "link") {
							itemValue.push(createLinkItem(item));
						} else if (item.type === "unit") {
							itemValue.push(createUnitItem(item));
						} else if (item.type === "poi") {
							const link = createPoiItem(item);

							link.addEventListener("click", (event: MouseEvent) => {
								event.preventDefault();

								store.dispatch(unsetDetail());
								Mapy.getComponent("detail").setState({
									source: item.srcSource,
									id: item.srcId,
									show: true,
								}).then(() => {
									Mapy.getComponent("history").save();
								}, () => { /**/ });
							});

							itemValue.push(link);
						}
					} else {
						itemValue.push(item.toString());
					}
				});

				tBody.append(createRow(`${name}:`, itemValue));
			}
		});

		table.append(tBody);
		this._dom.container.append(table);
		this._dom.container.append(dataSource);
	}
}
